import React from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { titv_show_path } from '@routes';
import { ClickTarget, ContentType, click } from '@tracking';
import { TITVEvent } from '@utils/backend-api/titv';

interface EventProps {
  event: TITVEvent;
}

const Event = ({ event }: EventProps) => {
  const { trackEvent } = useEventTracking({
    contentId: event.id,
    contentType: ContentType.TITVStream,
  });

  const handleClick = () => {
    trackEvent(click({ clickTarget: ClickTarget.TITVPastEvent, clickText: event.title }));
  };

  return (
    <a
      className="flex flex-col no-underline transition-colors hover:text-primary-magenta dark:hover:text-primary-pink"
      href={titv_show_path({ guid: event.guid })}
      onClickCapture={handleClick}
    >
      <div className="mb-8 cursor-pointer md:h-[157px] md:w-[280px] lg:h-[208px] lg:w-[370px]">
        <img
          src={event.coverUrl}
          alt={`${event.title} video thumbnail`}
          className="h-full w-full object-cover"
          loading="lazy"
        />
      </div>
      <div className="font-suisse-works text-headline-xxs">{event.title}</div>
      <span className="font-suisse-screen text-disclosure-sm text-grayscale-charcoal">
        {event.date}
      </span>
    </a>
  );
};

export default Event;
